import { createContext } from "react"
import type { SenjaVideoTestimonial } from "@/lib/senja-video-testimonials"
import type { SenjaWidgetGroupKey } from "@/lib/senja-widgets"

export type SenjaTestimonialsByGroup = Partial<
  Record<SenjaWidgetGroupKey, SenjaVideoTestimonial[]>
>

/** Server-resolved groups, shared separately so providers do not import the carousel. */
export const SenjaTestimonialsContext = createContext<SenjaTestimonialsByGroup>(
  {},
)
